import { cn } from "@edusogno/lib/utils";
import { useBreakpoint } from "@/utils/hooks/useBreakpoints";

/* eslint-disable react-refresh/only-export-components */
export enum ExerciseType {
  READING = "Reading",
  WRITING = "Writing",
  LISTENING = "Listening",
  GRAMMAR = "Grammar",
  SPEAKING = "Speaking",
  COMPREHENSION = "Comprehension",
}

type Props = {
  type: ExerciseType;
};

const ExerciseBadge = ({ type }: Props) => {
  const breakpoint = useBreakpoint();
  const isSmall = ["xs", "sm", "md"].indexOf(breakpoint) !== -1;

  return isSmall ? (
    <div
      className={cn(
        "h-[22px] px-2 text-[12px] flex items-center justify-center rounded-[5px] font-semibold",
        {
          "bg-[#6941C6] text-[#FFF]": type === ExerciseType.READING,
          "bg-[#392287] text-[#FFF]": type === ExerciseType.COMPREHENSION,
          "bg-[#C2ABFF] text-secondary": type === ExerciseType.LISTENING,
          "bg-brand-lavender text-secondary":
            type === ExerciseType.GRAMMAR || type === ExerciseType.SPEAKING,
        },
      )}
    >
      {type}
    </div>
  ) : (
    <div
      className={cn(
        "h-[22px] w-[120px] text-[12px] flex items-center justify-center rounded-[5px] font-semibold",
        {
          "border-[1px] border-solid border-[#C2ABFF] text-[#C2ABFF]":
            type === ExerciseType.READING,
          "bg-[#392287] text-[#FFF]": type === ExerciseType.COMPREHENSION,
          "bg-[#C2ABFF] text-secondary": type === ExerciseType.LISTENING,
          "bg-[#8065C9] text-[#FFF]": type === ExerciseType.WRITING,
          "bg-brand-lavender text-secondary":
            type === ExerciseType.GRAMMAR || type === ExerciseType.SPEAKING,
        },
      )}
    >
      {type}
    </div>
  );
};

export default ExerciseBadge;
